module.exports = __webpack_public_path__ + "img/zain-logo-black4.991d37cb.png";